import { Suspense, useEffect } from "react"
import { useNavigate } from "react-router-dom"

import LoginForm from "@/components/auth/login-form"
import { SSOAuth } from "@/components/auth/sso-auth"
import { FRONTEND_ROUTES } from "@/constants"
import { useAuth } from "@/contexts/auth"
export function LoginPage() {
  const navigate = useNavigate()
  const { authData } = useAuth()

  useEffect(() => {
    if (authData?.accessToken) {
      navigate(FRONTEND_ROUTES.DASHBOARD.href, {
        replace: true,
      })
    }
  }, [authData, navigate])

  return (
    <>
      <Suspense
        fallback={
          <p className="mb-6 text-center text-sm text-muted-foreground">
            Validando autenticação segura...
          </p>
        }
      >
        <SSOAuth />
      </Suspense>
      <LoginForm />
    </>
  )
}
